import { render } from "./chatLeftList.vue?vue&type=template&id=30f84c3d&scoped=true"
import script from "./chatLeftList.vue?vue&type=script&lang=js"
export * from "./chatLeftList.vue?vue&type=script&lang=js"

import "./chatLeftList.vue?vue&type=style&index=0&id=30f84c3d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-30f84c3d"

export default script